import axios from 'axios'

export default defineNuxtPlugin((nuxtApp) => {
  const baseAxios = axios.create({
    baseURL: '/bff-api/proxy',
    headers: {
      Accept: 'application/json',
    },
    withCredentials: true, // Important: send cookies with requests
  })

  // Request interceptor
  baseAxios.interceptors.request.use(async (config) => {
    // Get locale from i18n and set Accept-Language header
    const i18n = nuxtApp.$i18n
    const locale = i18n?.locale?.value || 'en'
    config.headers['Accept-Language'] = locale === 'en' ? 'en' : 'el'

    return config
  })

  // Response interceptor
  baseAxios.interceptors.response.use(
    (response) => response,
    async (error) => {
      // If we get a 401, redirect to sign in (token refresh is handled by BFF proxy)
      if (error.response?.status === 401) {
        const route = useRoute()
        const userStore = useUserStore()

        // Clear user data
        userStore.user = null

        // Redirect to sign in if not already on auth pages
        const authPages = ['/', '/authorize', '/sign-in']
        const cleanPath = route.path.replace(/^\/en(\/|$)/, '/')
        if (!authPages.includes(cleanPath)) {
          const localePath = useLocalePath()
          navigateTo(localePath('/'))
        }
      }

      // h3 (Nuxt BFF) wraps backend error data one level deeper:
      // error.response.data = { statusCode, statusMessage, data: { errors, ... } }
      // Hoist nested data.errors up so all pages can use error.response.data.errors consistently.
      const responseData = error.response?.data
      if (responseData?.data?.errors && !responseData.errors) {
        responseData.errors = responseData.data.errors
      }

      return Promise.reject(error)
    },
  )

  // Provide axios to the app
  return {
    provide: {
      axios: baseAxios,
    },
  }
})
